import TEXTS from "../../locale/texts";
import moment from 'moment';
import { HERMES_DETAILS_STATUSES, makeMsisdnBeautiful } from '../../Utils';
import { Tag } from 'antd';
import React from 'react';

export const detailsColumns = (lang = 'ru', pageSize, currentPage) =>
  // "clientMessageId": "88001",      
  // "messageId": "2020021115dc8d3462c3754030bba211261ff3565f",      
  // "sender": "5196",      
  // "msisdn": "77012115715", Номер абонента      
  // "initTime": "2020-02-11 09:59:43",  Время отправки    
  // "statusTime": "2020-02-11 09:59:44",   Время получения   
  // "segmentCount": 1,      Кол-во сегментов
  // "mobileOperator": "Kcell",     Оператор связи 
  // "status": "Delivered",    Статус  
  // "messageBody": "Testing status " Текст рассылки

  [
    {
      title: '#',
      width: 80,
      render: (text, record, index) => {
        const indexZeroBase = currentPage === 0
          ? index + 1
          : (index + 1 + (pageSize * currentPage));
        return indexZeroBase;
      }
    },
    {
      title: TEXTS.thMessageId[lang],
      dataIndex: 'clientMessageId',
      width: 170,
      render: (text) => (typeof text === 'number' || typeof text === 'string') ? text : '—'
    },
    {
      title: TEXTS.contactPhoneLabel[lang],
      dataIndex: 'msisdn',
      width: 180,
      render: (text) => (typeof text === 'number' || typeof text === 'string')
        ? makeMsisdnBeautiful(text) : '—'
    },
    // {
    //   title: "Время",
    //   // dataIndex: 'initTime',
    //   width: 170,
    //   render: (text, record) => {
    //     console.log('RRRRRRR', record);
    //     const initTime = typeof record.initTime === 'string'
    //       ? moment(record.initTime).format('DD.MM.YYYY HH:mm:ss') : '—';
    //     const statusTime = typeof record.statusTime === 'string'
    //       ? moment(record.statusTime).format('DD.MM.YYYY HH:mm:ss') : '—';
    //
    //     return(
    //       <div>
    //         {TEXTS.thInitTime[lang]}{': '}<br />
    //         {initTime}<br />
    //
    //         {TEXTS.thStatusTime[lang]}{': '}<br />
    //         {statusTime}<br />
    //       </div>
    //     );
    //   }
    // },
    {
      title: TEXTS.thInitTime[lang],
      dataIndex: 'initTime',
      width: 125,
      render: (text) => typeof text === 'string'
        ? moment(text).format('DD.MM.YYYY HH:mm:ss') : '—'
    },
    {
      title: TEXTS.thStatusTime[lang],
      dataIndex: 'statusTime',
      width: 125,
      render: (text) => typeof text === 'string'
        ? moment(text).format('DD.MM.YYYY HH:mm:ss') : '—'
    },
    {
      title: TEXTS.thSmsBody[lang],
      dataIndex: 'messageBody',
      width: 290,
      render: (text) => (typeof text === 'number' || typeof text === 'string') ? text : '—'
    },
    {
      title: TEXTS.thMobileOperator[lang],
      dataIndex: 'mobileOperator',
      width: 120,
      render: (text) => (typeof text === 'number' || typeof text === 'string') ? text : '—'
    },
    {
      title: TEXTS.campaignSmsBodySegmentsCount[lang],
      dataIndex: 'segmentCount',
      width: 130,
      render: (text) => (typeof text === 'number' || typeof text === 'string') ? text : '—'
    },
    {
      title: TEXTS.thCampaignStatus[lang],
      dataIndex: 'status',
      render: (text) => {
        const status = HERMES_DETAILS_STATUSES(lang)[text] || {};
        if (typeof text === 'number' || typeof text === 'string') {
          return (
            <Tag color={status.color}>
              {status.text}
            </Tag>
          );
        } else {
          return '—';
        }
      }
    }
  ];
